import m from 'mithril'


class Hotspot {
  view(vnode) {
    const hotspot = vnode.attrs.hotspot
    const Template = hotspot.template
    return (
      <div id={`hotspot-${hotspot.id}`} className="hotspot" onclick={vnode.attrs.onclick}>
        <Template hotspot={hotspot} />
      </div>
    )
  }
}
  export default Hotspot
